import { render, staticRenderFns } from "./ProgramsSeasons.vue?vue&type=template&id=fde1d954&"
import script from "./ProgramsSeasons.vue?vue&type=script&lang=js&"
export * from "./ProgramsSeasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports